
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class TreeMakingIssueGrid extends Serenity.EntityGrid<TreeMakingIssueRow, any> {
        protected getColumnsKey() { return 'Production.TreeMakingIssue'; }
        protected getDialogType() { return TreeMakingIssueDialog; }
        protected getIdProperty() { return TreeMakingIssueRow.idProperty; }
        protected getInsertPermission() { return TreeMakingIssueRow.insertPermission; }
        protected getLocalTextPrefix() { return TreeMakingIssueRow.localTextPrefix; }
        protected getService() { return TreeMakingIssueService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}